import React, { useContext } from 'react';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';

import { SimpleAppBar } from '_lib/components/AppBar/SimpleAppBar';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';

import { AppRouteContext } from '../App/app.types';
import { AuthContext } from '../auth/authContext';
import { appRoutePaths, getFullAppRoutePath, hasGoBack } from '../Nav/nav.types';

import { CallCenterCreate } from './CallCenterCreate';
import { CallCenterUpdate } from './CallCenterUpdate';

export const CallCenterDetailRoute = () => {
  const { appDrawerState } = useOutletContext<AppRouteContext>();

  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const location = useLocation();

  const { authUserCacheResource } = useContext(AuthContext);

  const cachedAuthUserQuery = authUserCacheResource.useCacheQuery();

  return (
    <FlexBox sx={{ flexDirection: 'column', height: '100%', width: '100%' }}>
      <SimpleAppBar
        title={id === 'new' ? 'Call Center Create' : 'Call Center'}
        onBackClicked={() => {
          const locationState = location.state;
          if (hasGoBack(locationState)) {
            navigate(locationState.goBack.url);
          } else {
            navigate(getFullAppRoutePath(appRoutePaths.CallCenter));
          }
        }}
        onAppDrawerToggleClicked={appDrawerState?.openSlidingDrawer}
      />
      {id === 'new' ? (
        <CallCenterCreate authUser={cachedAuthUserQuery.data} isFetchingFromProps={cachedAuthUserQuery.isFetching} />
      ) : (
        <CallCenterUpdate
          authUser={cachedAuthUserQuery.data}
          callCenterId={id}
          isFetchingFromProps={cachedAuthUserQuery.isFetching}
        />
      )}
    </FlexBox>
  );
};
